module.exports = __webpack_public_path__ + "img/aqhzf-5lmse.1e3fad3a.png";